// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["web/builds/site","web/builds/critical"], () => (__webpack_require__("./resources/scripts/bootstrap.js")))
__webpack_require__.O(undefined, ["web/builds/site","web/builds/critical"], () => (__webpack_require__("./resources/scss/critical.scss")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["web/builds/site","web/builds/critical"], () => (__webpack_require__("./resources/scss/site.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
